import {ErrorLogger} from "@kaspernj/api-maker"

const railsEnv = digg(window, "RAILS_ENV")

if (railsEnv == "test") {
  window.errorLogger = new ErrorLogger()
  window.errorLogger.enable()
}
